// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"273591a7","618":"907f41f3","730":"8bf81298","793":"1afd21ad","953":"342d01a9"}[chunkId] + ".chunk.js";
};